// Real meWATCH poster/thumbnail crops (captured from mewatch.sg for this pitch demo),
// mapped by genre so title cards show authentic imagery instead of flat gradients.
// Sports uses cropped match-action photography (crops fine — no baked-in text spanning
// the frame). Documentary/News/Variety are landscape text-logo thumbnails that cut
// mid-word under a straight 2:3 crop, so those are letterboxed instead — the source
// image sits centered, uncropped, over a blurred/darkened extension of itself filling
// the top and bottom bars (baked into the file itself, no card-level code changes).
const GENRE_POSTERS: Record<string, string[]> = {
  Comedy: ['coconut-hero', 'boonie-bears', 'fran-the-man', 'free-money', 'army-daze', 'the-best-bet'],
  Romance: ['rafael', 'with-or-without-you', 'midnight-at-the-paradise', 'mammal', 'india-sweets-and-spices'],
  Thriller: [
    'way-down',
    'detour',
    'mr-k',
    'the-maid',
    'shark-side-of-the-moon',
    'europa',
    'transporter-refueled',
    'transporter-3',
    'extinction',
  ],
  Kids: [
    'running-man-revengers',
    'slugterra-slug-fu-showdown',
    'slugterra-eastern-caverns',
    'slugterra-return-of-the-elementals',
    'slugterra-ghoul-from-beyond',
    'secrets-of-the-swamp',
    'spelling-armadillo',
    'zak-and-wowo',
    'dragonkeeper',
    'out-of-the-nest',
    'ultraman-blazar',
  ],
  'Original Series': [
    'falling-into-place',
    'singapore-dreaming',
    'traces-of-sandalwood',
    'homerun',
    'its-a-great-great-world',
    'our-sister-mambo',
    'dance-dance-dragon',
    'the-leap-years',
    'everything-everywhere-all-at-once',
    'lost-and-found',
  ],
  Sports: ['sports-vietnam-celebration', 'sports-vietnam-forward', 'sports-thailand-player'],
  Documentary: ['doc-breakthroughs', 'doc-walking-with-dinosaurs', 'doc-my-best-friends-an-animal'],
  News: ['news-news-tonight', 'news-asia-tonight', 'news-singapore-cannot-be-passive'],
  Variety: ['variety-unbeatable', 'variety-weakest-link', 'variety-kaypoh-room-tours'],
};

const GENRE_GRADIENTS: Record<string, string> = {
  Comedy: 'linear-gradient(135deg, #c98a3f, #7a4e1d)',
  Documentary: 'linear-gradient(135deg, #4a6d5c, #1d4a32)',
  Kids: 'linear-gradient(135deg, #d1a94a, #8a6a1e)',
  News: 'linear-gradient(135deg, #5a6b75, #2b3640)',
  'Original Series': 'linear-gradient(135deg, #7a5a8a, #3d2b4a)',
  Romance: 'linear-gradient(135deg, #b5545c, #6b2a30)',
  Sports: 'linear-gradient(135deg, #3f7a63, #1d4a32)',
  Thriller: 'linear-gradient(135deg, #4a4a52, #1c1c22)',
  Variety: 'linear-gradient(135deg, #8a8a3f, #4a4a1d)',
};

export function genreGradientFor(genre: string): string {
  return GENRE_GRADIENTS[genre] ?? 'linear-gradient(135deg, #4a6d5c, #1d4a32)';
}

function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

export function posterUrlFor(titleId: string, genre: string): string | null {
  const pool = GENRE_POSTERS[genre];
  if (!pool || pool.length === 0) return null;
  const pick = pool[hashString(titleId) % pool.length];
  return `${process.env.PUBLIC_URL}/posters/${pick}.jpg`;
}
